import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import QRCode from "qrcode";

const convertToBase64 = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve("/assets/images/idcard/student.png");
    img.src = url;
  });
};

export const capitalizeWords = (str) => {
  if (typeof str !== "string") return "";
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

const PrintingIdCard = async (data) => {
  if (!data) {
    toast.error("Missing Details", { position: "top-right" });
    return;
  }

  const students = Array.isArray(data) ? data : [data];
  const pdf = new jsPDF("landscape", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const cols = 5;
  const rows = 2;
  const finalCardWidthMM = 54;
  const finalCardHeightMM = 86;
  const cardSpacingX = 4;
  const cardSpacingY = 12;

  const totalGridWidth = cols * finalCardWidthMM + (cols - 1) * cardSpacingX;
  const totalGridHeight = rows * finalCardHeightMM + (rows - 1) * cardSpacingY;

  // Center the grid
  const horizontalMargin = (pageWidth - totalGridWidth) / 2;
  const verticalMargin = (pageHeight - totalGridHeight) / 2;

  const dpi = 100;
  const mmToPx = (mm) => (mm * dpi) / 25.4;

  for (let i = 0; i < students.length; i++) {
    const student = students[i];

    if (!student || !student.studentDetails) {
      console.warn(`Skipping invalid student data at index ${i}`);
      continue;
    }

    const admissionNo = student?.admission_no?.trim();
    if (!admissionNo) {
      toast.error("Missing Admission No for a student", {
        position: "top-right",
      });
      continue;
    }

    try {
      const studentImage = await convertToBase64(
        student.studentDetails.studentImage
      );
      const qrDataURL = await QRCode.toDataURL(admissionNo);

      const container = document.createElement("div");
      container.style.position = "fixed";
      container.style.top = "-10000px";
      container.style.left = "-10000px";
      container.style.width = `${mmToPx(finalCardWidthMM)}px`;
      container.style.height = `${mmToPx(finalCardHeightMM)}px`;
      container.style.backgroundColor = "#ff9201";
      container.style.backgroundImage = 'url("/assets/images/idcard/bg.jpg")';
      container.style.backgroundSize = "cover";
      container.style.fontFamily = "'Eczar', serif";
      container.style.padding = "0";

      container.innerHTML = `<div class="pb-1 px-2 mx-1 mt-1 position-relative z-1">
      <div class="d-flex align-items-center">
          <img
            src="/assets/images/icon.png"
            width="50"
            height="50"
          />
          <div class="ms-2">
            <h1 class="id-text-primary fs-3 fw-bold mb-0 lh-sm ls-sm eczar-font">आचार्यकुलम्</h1>
            <p class="id-text-primary printing-id-text-medium m-0 fw-bold lh-1 eczar-font"><i class="bi bi-geo-alt-fill"></i> Tata Road, Namkum, Ranchi - 834010</p>
            <p class="id-text-primary printing-id-text-medium m-0 fw-bold lh-1 eczar-font"><i class="bi bi-telephone-fill"></i> Phone No. (+91) 6287842460 / 64</p>
          </div>
      </div>
    </div>

    <div class="mx-1 mt-n1">
      <div class="p-2 my-1">
        <div class="row g-0">
          <div class="col-5">
            <div
              style="
                width: 78px;
                height: 78px;
                background-image: url('${studentImage}');
                background-size: cover;
                background-position: center;
                border-radius: 100%;
                border: 3px solid white;
              "
            ></div>
          </div>
          <div class="col-7 d-flex flex-column justify-content-center">
            <div class="mx-2 mt-1">
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">Admission No : <span class="fw-bold">${
                student?.admission_no
              }</span></p>
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">Class / Sec : <span class="fw-bold">${
                student?.currentClass
              } - ${student?.studentDetails?.currentSection}</span></p>
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">Roll No : <span class="fw-bold">${
                student?.studentDetails?.rollNo
              }</span></p>
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">DOB : <span class="fw-bold">${new Date(
                student?.studentDetails?.dateOfBirth
              ).toLocaleDateString("en-GB")}</span></p>
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">House : <span class="fw-bold">${capitalizeWords(
                student?.studentDetails?.house
              )}</span></p>
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">Blood Group : <span class="fw-bold">${
                student?.studentDetails?.bloodGroup
              }</span></p>
              <p class="text-dark printing-id-text-normal m-0 fw-medium lh-sm eczar-font">Session : <span class="fw-bold">${
                student?.session
              }</span></p>
            </div>
            <div class="d-flex justify-content-end mt-4">
              <img src="${qrDataURL}"
                width="40"
                height="40"
                class="rounded-2 bg-white border border-secondary"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 mt-n7">
        <div class="row g-0">
          <div class="col-12">
            <div class="col-9">
              <p class="text-dark fs-6 m-0 text-uppercase eczar-font mb-1 lh-1 pt-0"><b>${
                student?.studentDetails?.name
              }</b></p>
            </div>
            <p class="text-dark printing-id-text-medium m-0 fw-medium lh-1 eczar-font">Father's Name</p>
            <p class="text-dark printing-id-text-large m-0 fw-medium eczar-font text-uppercase"><i class="bi bi-person-fill id-icon-primary"></i> ${capitalizeWords(
              student?.parentDetails?.[0]?.name || ""
            )}</p>
            <p class="text-dark printing-id-text-medium m-0 fw-medium lh-1 eczar-font">Mother's Name</p>
            <p class="text-dark printing-id-text-large m-0 fw-medium eczar-font text-uppercase"><i class="bi bi-person-fill id-icon-primary"></i> ${capitalizeWords(
              student?.parentDetails?.[1]?.name || ""
            )}</p>
            <p class="text-dark printing-id-text-medium m-0 fw-medium lh-1 eczar-font">Address :</p>
            <p class="text-dark printing-id-text-large m-0 fw-medium lh-1 eczar-font"><i class="bi bi-geo-alt-fill id-icon-primary"></i> ${capitalizeWords(
              student?.presentAddress?.address || ""
            )}</p>
            <p class="text-dark printing-id-text-medium m-0 pt-1 fw-medium lh-1 eczar-font">Phone No :</p>
            <p class="text-dark printing-id-text-large m-0 fw-medium eczar-font"><i class="bi bi-telephone-fill id-icon-primary"></i> (+91) ${
              student?.parentDetails[0]?.phone
            }</p>
            <p class="text-dark printing-id-text-medium m-0 fw-medium lh-1 eczar-font">Bus Stoppage :</p>
            <p class="text-dark printing-id-text-large m-0 fw-medium eczar-font text-uppercase"><i class="bi bi-bus-front-fill id-icon-primary"></i> ${capitalizeWords(
              student?.transportFacility?.busStop || "NONE"
            )}</p>
            <div class="d-flex"><p class="text-dark printing-id-text-medium m-0 fw-medium me-2 eczar-font"> ${
              student.transportFacility?.busNumber ? "Bus No" : "Walker"
            } :</p> <div class="printing-id-circle">
                  <div class="id-content">
                    <b class="text-dark fs-6 m-0 fw-bold eczar-font">
                      ${
                        student.transportFacility.busNumber ||
                        '<i class="bi bi-person-walking"></i>'
                      }
                    </b>
                  </div>
                </div>
            </div>
          </div>
        </div>
        
        <div class="float-end mt-n5">
          <div class="me-2 text-center">
            <img
              src="/assets/images/idcard/director.png"
              width="45"
              height="25"
              class="object-fit-contain"
            />
            <p class="text-dark printing-id-text-medium m-0 fw-bold lh-sm eczar-font">Issuing Authority</p>
          </div>
        </div>
      </div>
    </div>`;

      document.body.appendChild(container);

      const canvas = await html2canvas(container, {
        scale: 3,
        useCORS: true,
        width: container.offsetWidth,
        height: container.offsetHeight,
      });

      container.remove();

      const positionOnPage = i % (cols * rows);
      const colIndex = positionOnPage % cols;
      const rowIndex = Math.floor(positionOnPage / cols);

      const x = horizontalMargin + colIndex * (finalCardWidthMM + cardSpacingX);
      const y = verticalMargin + rowIndex * (finalCardHeightMM + cardSpacingY);

      if (positionOnPage === 0 && i !== 0) {
        pdf.addPage();
      }

      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(
        imgData,
        "PNG",
        x,
        y,
        finalCardWidthMM,
        finalCardHeightMM,
        "",
        "FAST"
      );
    } catch (err) {
      console.error(`Failed to render student at index ${i}`, err);
      toast.error(
        `Error Rendering Student: ${student?.studentDetails?.name || "Unknown"}`
      );
    }
  }

  pdf.save("IDCard.pdf");
};

export default PrintingIdCard;
